import React from 'react';
import { StyleSheet } from 'react-native';

import { blurTargetRefHome } from '@/components/ui/tabbar/tabbar';
import { STRINGS } from '@/constants/strings';
import { DashboardScreen } from '@/features/home/screens/dashboard-screen';
import { OverviewSessionScreen } from '@/features/player-session/screens/overview-session-screen';
import { SelectPlayerScreen } from '@/features/player-session/screens/select-player-screen';
import SessionSummaryScreen from '@/features/player-session/screens/session-summary-screen';
import { PlayerProfileScreen } from '@/features/player/screens/player-profile-screen';
import { withActiveSession } from '@/hocs/with-active-session';
import { HomeStackParamList } from '@/navigations/types';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { BlurTargetView } from 'expo-blur';

const Stack = createNativeStackNavigator<HomeStackParamList>();

// Created once — an inline `withActiveSession(OverviewSessionScreen)` would hand React Navigation a
// new component identity on every re-render, remounting the route and resetting its state. See the
// same fix in root-navigator.tsx.
const OverviewSessionScreenGuarded = withActiveSession(OverviewSessionScreen);

export function HomeStackNavigator() {
  return (
    <BlurTargetView ref={blurTargetRefHome} style={styles.blurTarget} collapsable={false}>
      <Stack.Navigator
        initialRouteName="Dashboard"
        screenOptions={{
          headerShown: false,
          title: STRINGS.appDocumentTitle,
        }}>
        <Stack.Screen name="Dashboard" component={DashboardScreen} />
        <Stack.Screen name="OverviewSession" component={OverviewSessionScreenGuarded} />
        <Stack.Screen name="SelectPlayer" component={SelectPlayerScreen} />
        <Stack.Screen name="PlayerProfile" component={PlayerProfileScreen} />
        <Stack.Screen name="SessionSummary" component={SessionSummaryScreen} />
      </Stack.Navigator>
    </BlurTargetView>
  );
}

const styles = StyleSheet.create({
  blurTarget: {
    flex: 1,
  },
});
